@if (isUserLoaded) {
<nz-layout
  [class]="'app-layout' + (uatEnv ? ' color-uat' :  devEnv ? ' color-dev'  : localEnv ? ' color-local' : ' color-prod')">
  <nz-sider class="menu-sidebar" id="sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md"
    [(nzCollapsed)]="isCollapsed" [nzTrigger]="null">
    <div class="sidebar-sticky">
      <div class="sidebar-logo">
        <h1 class="{{isCollapsed ? 'small-title' : ''}}"> {{isCollapsed ? 'PSO' : ('app.appName' | translate)}}
        </h1>
      </div>
      <div class="sider-bump" (click)="isCollapsed = !isCollapsed">
        <span class="header-trigger">
          <span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
        </span>
      </div>
      <app-user-profile [sidebarCollapsed]="isCollapsed"></app-user-profile>
      <ul nz-menu nzTheme="dark" nzMode="inline" class="sidebar-menu">
        <li nz-menu-item [nzTooltipTitle]="isCollapsed ? ('nav.dashboard' | translate) : ''" nz-tooltip
          nzTooltipPlacement="right" [nzTooltipColor]="derichebourgColorBlue" routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: true }">
          <a [routerLink]="['']" nzMatchRouter>
            <span nz-icon nzType="dashboard" nzTheme="outline" class="icon-lg"></span>
            <span>{{ 'nav.dashboard' | translate }}
            </span>
          </a>
        </li>
        <li nz-menu-item [nzTooltipTitle]="isCollapsed ? ('nav.perimeter' | translate) : ''" nz-tooltip
          nzTooltipPlacement="right" [nzTooltipColor]="derichebourgColorBlue" routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/perimeter']" nzMatchRouter>
            <span nz-icon nzType="appstore" nzTheme="outline" class="icon-lg"></span>
            <span>{{ 'nav.perimeter' | translate }}
            </span>
          </a>
        </li>
        <li nz-menu-item [nzTooltipTitle]="isCollapsed ? ('nav.planAction' | translate) : ''" nz-tooltip
          nzTooltipPlacement="right" [nzTooltipColor]="derichebourgColorBlue" routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/action']" nzMatchRouter>
            <span nz-icon nzType="file-done" nzTheme="outline" class="icon-lg"></span>
            <span>{{ 'nav.planAction' | translate }}</span>
          </a>
        </li>
        <li nz-menu-item [nzTooltipTitle]="isCollapsed ? ('nav.kpi' | translate) : ''" nz-tooltip
          nzTooltipPlacement="right" [nzTooltipColor]="derichebourgColorBlue" routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/dashboard/kpi']" nzMatchRouter>
            <span nz-icon nzType="bar-chart" nzTheme="outline" class="icon-lg"></span>
            <span>{{ 'nav.kpi' | translate }}</span>
          </a>
        </li>
        <li nz-menu-item [nzTooltipTitle]="isCollapsed ? ('nav.catalog' | translate) : ''" nz-tooltip
          nzTooltipPlacement="right" [nzTooltipColor]="derichebourgColorBlue" routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: true }">
          <a [routerLink]="['/catalog']" nzMatchRouter>
            <span nz-icon nzType="folder-open" nzTheme="outline" class="icon-lg"></span>
            <span>{{ 'nav.catalog' | translate }}</span>
          </a>
        </li>
        @if(adminPerimeterAccess) {
        <li nz-menu-item [nzTooltipTitle]="isCollapsed ? ('nav.user' | translate) : ''" nz-tooltip
          nzTooltipPlacement="right" [nzTooltipColor]="derichebourgColorBlue" routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/user']" nzMatchRouter>
            <span nz-icon nzType="user" nzTheme="outline" class="icon-lg"></span>
            <span>{{ 'nav.user' | translate }}</span>
          </a>
        </li>
        }
        @if(isAdmin || isAdminManagement) {
        <li nz-submenu class="admin-submenu">
          <span title [ngClass]="'admin-submenu-title'">
            <span nz-icon nzType="setting" nzTheme="outline" class="icon-lg"></span>
            <span>{{ 'nav.admin' | translate }}</span>
          </span>
          <ul class="admin-submenu-list">
            <li nz-menu-item class="admin-submenu-item"
              [ngClass]="[isCollapsed ? 'admin-submenu-item-collapsed' : '', uatEnv ? 'color-uat' : devEnv ? 'color-dev' : localEnv ? 'color-local' : 'color-prod']"
              routerLinkActive="ant-menu-item-selected" [routerLinkActiveOptions]="{ exact: true }">
              <a [routerLink]="['/management']" nzMatchRouter>
                <span>{{ 'menu.management' | translate }}</span>
              </a>
            </li>
            <li nz-menu-item class="admin-submenu-item"
              [ngClass]="[isCollapsed ? 'admin-submenu-item-collapsed' : '', uatEnv ? 'color-uat' : devEnv ? 'color-dev' : localEnv ? 'color-local' : 'color-prod']"
              routerLinkActive="ant-menu-item-selected" [routerLinkActiveOptions]="{ exact: true }">
              <a [routerLink]="['/sector']" nzMatchRouter>
                <span>{{ 'nav.sector' | translate }}</span>
              </a>
            </li>
            @if(isAdmin || isAdminManagement) {
            <li nz-menu-item class="admin-submenu-item"
              [ngClass]="[isCollapsed ? 'admin-submenu-item-collapsed' : '', uatEnv ? 'color-uat' : devEnv ? 'color-dev' : localEnv ? 'color-local' : 'color-prod']"
              routerLinkActive="ant-menu-item-selected" [routerLinkActiveOptions]="{ exact: true }">
              <a [routerLink]="['/catalog/admin']" nzMatchRouter>
                <span>{{ 'nav.adminCatalog' | translate }}</span>
              </a>
            </li>
            }

            @if(isAdmin || isAdminManagement) {
            <li nz-menu-item class="admin-submenu-item"
              [ngClass]="[isCollapsed ? 'admin-submenu-item-collapsed' : '', uatEnv ? 'color-uat' : devEnv ? 'color-dev' : localEnv ? 'color-local' : 'color-prod']"
              routerLinkActive="ant-menu-item-selected" [routerLinkActiveOptions]="{ exact: true }">
              <a [routerLink]="['/spj']" nzMatchRouter>
                <span>{{ 'nav.adminSPJ' | translate }}</span>
              </a>
            </li>
            }
            @if(isAdmin){
            <li nz-menu-item class="admin-submenu-item"
              [ngClass]="[isCollapsed ? 'admin-submenu-item-collapsed' : '', uatEnv ? 'color-uat' : devEnv ? 'color-dev' : localEnv ? 'color-local' : 'color-prod']"
              routerLinkActive="ant-menu-item-selected" [routerLinkActiveOptions]="{ exact: true }">
              <a [routerLink]="['/monitoring-sheet/admin']" nzMatchRouter>
                <span>{{ 'admin.fso.header' | translate }}</span>
              </a>
            </li>
            }
          </ul>
        </li>
        }
        @if(isSuperAdmin) {
        <li nz-menu-item [nzTooltipTitle]="isCollapsed ? 'Utilisateurs' : ''" nz-tooltip nzTooltipPlacement="right"
          [nzTooltipColor]="derichebourgColorBlue" routerLinkActive="ant-menu-item-selected"
          [routerLinkActiveOptions]="{ exact: false }">
          <a [routerLink]="['/admin/super-admin']" nzMatchRouter>
            <span nz-icon nzType="user" nzTheme="outline"></span>
            <span>Super Admin</span>
          </a>
        </li>
        }
        <!-- <li nz-submenu nzOpen nzTitle="Dashboard" nzIcon="dashboard">
        <ul>
          <li nz-menu-item nzMatchRouter>
            <a [routerLink]="['/perimeter']">
              <span nz-icon nzType="appstore" nzTheme="outline"></span>
              Périmètres
            </a>
          </li>
          <li nz-menu-item nzMatchRouter>
            <a [routerLink]="['/action']">
              <span nz-icon nzType="file-done" nzTheme="outline"></span>
              Plan d'actions
            </a>
          </li>
          @if(adminPerimeterAccess) {
          <li nz-menu-item nzMatchRouter>
            <a [routerLink]="['/user']">
              <span nz-icon nzType="user" nzTheme="outline"></span>
              Utilisateurs
            </a>
          </li>
          }
        </ul>
      </li> -->
      </ul>
      @if (uatEnv) {
      <div class="uat-text">
        <p>{{ 'app.uat.warningStart' | translate }} <b>{{ 'app.uat.appName' | translate }}</b>. {{ 'app.uat.warningEnd'
          | translate }}</p>
        <p>{{ 'app.uat.supportText' | translate }}
          <a target="_blank"
            href="https://forms.office.com/Pages/ResponsePage.aspx?id=DJU9Dijw7EOWO8BgJ15rvJbATe2KyKJPueLZIZgTt7pUNUI5T0ZHT0NBQ1BOTlBaNUFKNlkyUlNOMyQlQCN0PWcu">{{
            'app.uat.supportLink' | translate }}</a>
        </p>
      </div>
      }
      <div class="logo-div">
        <img nz-image class="{{ isCollapsed ?'image-logo-small' :  'image-logo'}}"
          nzSrc=" {{isCollapsed ? 'assets/images/Elior_Group_Logotype_Bison_Blanc.png' : 'assets/images/Derichebourg_Aeronautics_Services_Logotype_Blanc.png'}}"
          alt="logo derichebourg" />
      </div>
      <app-qr-code-app [sidebarCollapsed]="isCollapsed"></app-qr-code-app>
    </div>
  </nz-sider>
  <nz-layout>
    <!-- <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
        </span>
      </div>
    </nz-header> -->
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
    <nz-footer>
      <div id="footer">
        <a [routerLink]="['/home/contact']">{{ 'footer.links.contactSupport' | translate }}</a>
        <nz-divider nzType="vertical"></nz-divider>
        <a [routerLink]="['/home/legal-notices']">{{ 'footer.links.legalNotices' | translate }}</a>
        <nz-divider nzType="vertical"></nz-divider>
        <a [routerLink]="['/home/personal-datas']">{{ 'footer.links.personalData' | translate }}</a>
        <nz-divider nzType="vertical"></nz-divider>
        <a [routerLink]="['/home/cookies']">{{ 'footer.links.cookies' | translate }}</a>
      </div>
    </nz-footer>
    <nz-back-top class="back-to-top"></nz-back-top>
  </nz-layout>
</nz-layout>
}